(function () {
  'use strict';

  const BREAKPOINT = 750;
  const GAP = 20;

  function init() {
    const grid = document.querySelector('.product-information__grid');
    const left = document.querySelector('.product-information__media');
    const right = document.querySelector('.product-details');

    if (!grid || !left || !right) return;

    const pw = document.querySelector('.page-wrapper');
    const scrollTarget = (pw && getComputedStyle(pw).overflowY === 'auto') ? pw : window;

    let leftH = 0;
    let rightH = 0;
    let phase1 = 0;
    let phase2 = 0;
    let raf = null;

    function stickyTop() {
      const local = parseFloat(getComputedStyle(right).getPropertyValue('--sticky-header-offset')) || 0;
      const root = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sticky-header-offset')) || 0;
      return (local || root) + GAP;
    }

    function reset() {
      left.style.transform = '';
      right.style.transform = '';
      grid.style.minHeight = '';
    }

    function measure() {
      reset();

      if (window.innerWidth < BREAKPOINT) return;

      const top = stickyTop();
      const usableViewport = window.innerHeight - top - GAP;

      leftH = left.offsetHeight;
      rightH = right.offsetHeight;

      const hasOpenAccordion = !!left.querySelector('details[open]');
      const isCoordinated = hasOpenAccordion || leftH > rightH;

      if (isCoordinated) {
        phase1 = Math.max(0, rightH - usableViewport);
        phase2 = Math.max(0, leftH - usableViewport);
        // Reserve exact height so left is held during phase1 without overlapping next section
        grid.style.minHeight = Math.ceil(leftH + phase1) + 'px';
      } else {
        phase1 = 0;
        phase2 = 0;
        grid.style.minHeight = '';
      }

      update();
    }

    function update() {
      raf = null;

      if (window.innerWidth < BREAKPOINT) {
        reset();
        return;
      }

      const top = stickyTop();
      const hasOpenAccordion = !!left.querySelector('details[open]');
      const isCoordinated = hasOpenAccordion || leftH > rightH;
      const gridRect = grid.getBoundingClientRect();
      const scrolled = Math.max(0, top - gridRect.top);

      let leftY = 0;
      let rightY = 0;

      if (!isCoordinated) {
        // STATE 1: Description Closed - Left sticks until bottom aligns with right, zero gap
        const maxSticky = Math.max(0, rightH - leftH);
        leftY = Math.min(scrolled, maxSticky);
        rightY = 0;
      } else {
        // STATE 2: Description Open - Right scrolls first (Phase 1), pins (Phase 2), both finish together (Phase 3)
        const end = phase1 + phase2;

        if (scrolled <= phase1) {
          leftY = scrolled;
          rightY = 0;
        } else if (scrolled <= end) {
          leftY = phase1;
          rightY = scrolled - phase1;
        } else {
          leftY = phase1;
          rightY = phase2;
        }
      }

      // Guarded writes: at scroll rest these values are unchanged frame to
      // frame. Assigning anyway invalidates style and forces the next
      // frame's getBoundingClientRect() to re-run layout.
      const nextLeft = leftY ? `translate3d(0, ${Math.round(leftY)}px, 0)` : '';
      const nextRight = rightY ? `translate3d(0, ${Math.round(rightY)}px, 0)` : '';
      if (left.style.transform !== nextLeft) left.style.transform = nextLeft;
      if (right.style.transform !== nextRight) right.style.transform = nextRight;
    }

    function onScroll() {
      if (!raf) raf = requestAnimationFrame(update);
    }

    // When scrollTarget resolves to window the previous code registered the
    // same handler on window twice. The document-level capture listener is
    // kept: scroll events do not bubble from inner scrollable elements, so
    // it is the only one that sees them.
    scrollTarget.addEventListener('scroll', onScroll, { passive: true });
    if (scrollTarget !== window) {
      window.addEventListener('scroll', onScroll, { passive: true });
    }
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });

    const ro = new ResizeObserver(() => { measure(); });
    ro.observe(left);
    ro.observe(right);

    window.addEventListener('resize', measure, { passive: true });

    document.addEventListener('toggle', (e) => {
      if (e.target.tagName === 'DETAILS' && grid.contains(e.target)) {
        setTimeout(measure, 30);
        setTimeout(measure, 250);
      }
    }, true);

    grid.addEventListener('change', () => { setTimeout(measure, 50); });

    measure();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();